import Dispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';

const isFetching = ({isFetching}, action) => {
    switch (action.type) {
        case ActionTypes.MANAGER_LIST_REQUEST:
            return isFetching + 1;

        case ActionTypes.MANAGER_LIST_SUCCESS:
            return isFetching - 1;

        case ActionTypes.MANAGER_LIST_FAILURE:
            return isFetching - 1;

        default:
            return isFetching;
    }
};

const managers = ({managers}, action) => {
    switch (action.type) {
        case ActionTypes.MANAGER_LIST_SUCCESS:
            return [...action.data];

        default:
            return managers;
    }
};

class ManagerStore extends ReduceStore {

    getInitialState() {
        return {
            isFetching: 0,
            managers: [],
        };
    }

    isFetching() {
        return this.getState().isFetching > 0;
    }

    getAll() {
        return this.getState().managers;
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.MANAGER_LIST_REQUEST:
            case ActionTypes.MANAGER_LIST_SUCCESS:
            case ActionTypes.MANAGER_LIST_FAILURE:
                return {
                    isFetching: isFetching(state, action),
                    managers: managers(state, action),
                };

            default:
                return state;
        }
    }
}

export default new ManagerStore(Dispatcher);
